<template>
    <section class="detail-news">
     <div class="detail-news__container container">
            <div class="row">
                <div class="col-default-8 col-default-offset-1 col-tablet-12 col-tablet-offset-0">
                    <div class="detail-news__tags">
                        <span class="detail-news-tag detail-news-tag--image" v-if="data.item.hasPhoto.xmlId === 'Y'"/>
                        <span class="detail-news-tag detail-news-tag--video" v-if="data.item.hasVideo.xmlId === 'Y'"/>
                        <z-share :services="['vkontakte', 'odnoklassniki', 'telegram', 'viber', 'whatsapp', 'moimir', 'lj']" :url="data.item.detailPageUrl">
                            <z-icon name="round/share" width="48" height="48" />
                        </z-share>
                    </div>
                    <vue-raw class="detail-news__content" :raw="data.item.detailText" />
                    <div v-if="data.item.detailPicture.link" class="detail-news__img">
                        <z-image :src="data.item.detailPicture.link" alt="" />
                    </div>
                    <div v-if="data.item.detailVideo.value" class="detail-news__video">
                        <z-figure video :caption="data.item.detailVideo.description">
                            <z-video
                                :autoplay="false"
                                :src="data.item.detailVideo.value"
                            ></z-video>
                        </z-figure>
                    </div>
                    <div v-if="data.item.detailVkVideo.value" class="detail-news__video">
                        <z-figure video :caption="data.item.detailVkVideo.description">
                            <iframe
                                width="100%"
                                height="100%"
                                :src="data.item.detailVkVideo.value"
                                frameborder="0"
                                allowfullscreen>
                            </iframe>
                        </z-figure>
                    </div>
                    <section class="detail-news-files" v-if="data.item.documents.length">
                        <h3 class="detail-news-files__title">Документы</h3>
                        <z-filelist horizontal>
                            <template v-for="(item, index) in data.item.documents">
                                <z-filelist-item :icon="`file/${item.type}`" :info="item.size" :key="`file-${index}`">
                                    <z-link :href="item.link" target="_blank">{{item.name}}</z-link>
                                </z-filelist-item>
                            </template>
                        </z-filelist>
                    </section>
                    <template v-if="data.item.type.xmlId !== 'corporate'">
                        <div class="detail-news-source" v-if="data.item.source.value || data.item.author.value || data.item.source.description">
                            <div class="detail-news-source__item" v-if="data.item.source.value">
                                <span class="detail-news-source__title">Источник:</span>
                                <z-link :href="data.item.source.value" icon-position="right" external target="_blank">{{data.item.source.description}}</z-link>
                            </div>
                            <div class="detail-news-source__item" v-if="data.item.author.value">
                                <span class="detail-news-source__title">Автор:</span>
                                <span class="detail-news-source__value">{{data.item.author.value}}</span>
                            </div>
                            <div class="detail-news-source__item" v-if="data.item.date.timestamp">
                                <span class="detail-news-source__title">Дата публикации:</span>
                                <span class="detail-news-source__value">{{data.item.date.timestamp | momentFilter('DD MMMM YYYY')}}</span>
                            </div>
                        </div>
                    </template>
                    <page-changer
                        :data="{
                            next: {
                                name: '',
                                url: data.nav.next ?  data.nav.next.url : ''
                            },
                            prev: {
                                name: '',
                                url: data.nav.prev ? data.nav.prev.url : ''
                            },
                            ['back-link']: data.nav['back-link']
                        }"
                    />
                    <div class="detail-news-events u-block-fluid u-top-margin--l bg-10-bg" v-if="data.item.linkEvent && data.item.linkEvent.length">
                        <events-block :data="data.item.linkEvent"></events-block>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions } from 'vuex'
import {mixinDevice} from '../../utils/mixin'
import EventsBlock from '@/views/Events/EventsBlock'

export default {
    name: 'detail-news',
    mixins: [mixinDevice],
    components: {
        EventsBlock
    },
    data () {
        return {
            data: this.$root.app.components['news-detail']
        }
    },
    created () {
        this.SetHeroTitle(this.data.item.name)
    },
    methods: {
        ...mapActions(['SetHeroTitle'])
    }
}
</script>

<style lang="scss">
.detail-news {
    margin-bottom: $token-spacers-s;

    &__tags {
        display: flex;
        margin-bottom: $token-spacers-xs;
    }

    .share-tooltip {
        &:not(:first-child) {
            margin-left: $token-spacers-2-xs;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        @include margin-level(bottom, L);
    }

    &__hero {
        margin-top: 0;

        & .z-hero__date {
            color: $token-colors-white;
        }
    }

    &__container {
        @include padding-level(top, 2XL);
        // margin-top: -30px;
        background-color: $token-colors-bg-5;
        overflow: hidden;
        border-top-left-radius: $borderRadius;
        border-top-right-radius: $borderRadius;
        position: relative;
        z-index: 2;
        padding-left: $token-grids-desktop-offset;
        padding-right: $token-grids-desktop-offset;
        padding-bottom: $token-grids-desktop-offset;

        @include breakpoint(laptop) {
            padding-right: $token-grids-laptop-offset;
            padding-left: $token-grids-laptop-offset;
            padding-bottom: $token-grids-laptop-offset;
        }

        @include breakpoint(tablet) {
            padding-right: $token-grids-tablet-offset;
            padding-left: $token-grids-tablet-offset;
            padding-bottom: $token-grids-tablet-offset;
        }

        @include breakpoint(v-tablet) {
            padding-right: $token-grids-v-tablet-offset;
            padding-left: $token-grids-v-tablet-offset;
            padding-bottom: $token-grids-v-tablet-offset;
        }

        @include breakpoint(mobile) {
            padding-right: $token-grids-mobile-offset;
            padding-left: $token-grids-mobile-offset;
            padding-bottom: $token-grids-mobile-offset;
        }
    }

    & iframe {
        aspect-ratio: 16 / 9;
        max-width: 1150px;
        display: flex;
        width: 100%;
        height: unset;
    }

    & .z-link--underlined {
        vertical-align: bottom;
    }
}

.detail-news-events {
    @include padding-level (top, 2XL);
    padding-bottom: calc(#{$token-spacers-2-xl} + #{$borderRadius});
    margin-bottom: calc((#{$token-spacers-2-xl} + #{$borderRadius}) * -1);
}

.detail-news-tag {
    display: inline-block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: center;

    &:not(:first-child) {
        margin-left: $token-spacers-2-xs;
    }

    &--image {
        background-color: #F9B533;
        background-image: url("data:image/svg+xml,%3Csvg width='33' height='33' viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.403 2.39996H18.3968C20.9403 2.39993 22.9904 2.3999 24.6028 2.61126C26.2769 2.8307 27.6864 3.30016 28.8059 4.39164C29.9253 5.48311 30.4068 6.85739 30.6319 8.48959C30.8487 10.0617 30.8486 12.0606 30.8486 14.5405V17.4594C30.8486 19.9393 30.8487 21.9382 30.6319 23.5103C30.4068 25.1425 29.9253 26.5168 28.8059 27.6083C27.6864 28.6998 26.2769 29.1692 24.6028 29.3887C22.9904 29.6 20.9403 29.6 18.3968 29.6H15.403C12.8595 29.6 10.8094 29.6 9.19694 29.3887C7.52289 29.1692 6.11338 28.6998 4.99392 27.6083C3.87445 26.5168 3.39296 25.1425 3.16789 23.5103C2.9511 21.9382 2.95113 19.9394 2.95117 17.4595V14.5405C2.95113 12.0606 2.9511 10.0617 3.16789 8.48959C3.39296 6.85739 3.87445 5.48311 4.99392 4.39164C6.11338 3.30016 7.52289 2.8307 9.19694 2.61126C10.8094 2.3999 12.8595 2.39993 15.403 2.39996ZM9.56867 5.307C8.20397 5.4859 7.48129 5.81311 6.96656 6.31497C6.45183 6.81683 6.11623 7.52144 5.93275 8.85202C5.74388 10.2217 5.74092 12.0371 5.74092 14.64V17.36C5.74092 19.9629 5.74388 21.7782 5.93275 23.1479C6.11623 24.4785 6.45183 25.1831 6.96656 25.685C7.48129 26.1868 8.20397 26.514 9.56867 26.6929C10.9735 26.8771 12.8354 26.88 15.505 26.88H18.2948C20.9644 26.88 22.8263 26.8771 24.2311 26.6929C25.5958 26.514 26.3185 26.1868 26.8332 25.685C27.3479 25.1831 27.6835 24.4785 27.867 23.1479C28.0559 21.7782 28.0589 19.9629 28.0589 17.36V14.64C28.0589 12.0371 28.0559 10.2217 27.867 8.85202C27.6835 7.52144 27.3479 6.81683 26.8332 6.31497C26.3185 5.81311 25.5958 5.4859 24.2311 5.307C22.8263 5.12285 20.9644 5.11996 18.2948 5.11996H15.505C12.8354 5.11996 10.9735 5.12285 9.56867 5.307Z' fill='%23FFEDCB'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M26.746 18.0406L26.7162 18.0145C26.1453 17.5143 25.6528 17.0828 25.2132 16.7582C24.7488 16.4153 24.2434 16.1138 23.6203 15.9492C22.7923 15.7303 21.909 15.7303 21.081 15.9492C20.458 16.1138 19.9525 16.4153 19.4882 16.7582C19.0486 17.0828 18.5561 17.5143 17.9852 18.0145L17.9434 18.0511C17.4938 18.445 17.2291 18.6749 17.0239 18.8236L16.9943 18.8447L16.9758 18.8155C16.8483 18.6106 16.7 18.311 16.4495 17.799L16.3713 17.6391L16.3389 17.5729L16.3389 17.5728C15.8174 16.5066 15.3794 15.6113 14.946 14.9366C14.4994 14.2413 13.9429 13.5893 13.0755 13.2084C12.352 12.8906 11.5424 12.754 10.736 12.8136C9.76909 12.8851 8.97601 13.3094 8.26665 13.8096C7.67272 14.2284 7.00612 14.7985 6.23315 15.4738V17.2889C6.23315 17.9523 6.23359 18.5532 6.23767 19.1004L7.86981 17.6705C8.87959 16.7858 9.55394 16.1975 10.1041 15.8096C10.6475 15.4264 10.8813 15.3794 10.9824 15.3719C11.2512 15.352 11.5211 15.3975 11.7622 15.5035C11.8529 15.5433 12.05 15.663 12.3922 16.1957C12.7385 16.7348 13.1152 17.5005 13.6778 18.6504L13.756 18.8104L13.78 18.8593C13.9981 19.3054 14.2008 19.7199 14.4031 20.0448C14.6152 20.3854 14.9231 20.7934 15.4417 21.0746C16.0531 21.4062 16.7823 21.5292 17.4906 21.4203C18.0913 21.3279 18.5502 21.0493 18.8914 20.8021C19.217 20.5662 19.5808 20.2474 19.9725 19.9041L19.9726 19.9041L20.0155 19.8665C20.64 19.3194 21.0441 18.9669 21.3767 18.7213C21.6952 18.4862 21.8455 18.4288 21.9275 18.4071C22.2035 18.3341 22.4979 18.3341 22.7739 18.4071C22.8559 18.4288 23.0062 18.4862 23.3247 18.7213C23.6572 18.9669 24.0613 19.3194 24.6858 19.8665L26.6645 21.6C26.732 20.6785 26.7439 19.5329 26.746 18.0406Z' fill='%23FFEDCB'/%3E%3Cpath d='M24.2845 10C24.2845 11.1046 23.5498 12 22.6435 12C21.7372 12 21.0024 11.1046 21.0024 10C21.0024 8.89543 21.7372 8 22.6435 8C23.5498 8 24.2845 8.89543 24.2845 10Z' fill='%23FFEDCB'/%3E%3C/svg%3E");
    }

    &--video {
        background-color: $token-colors-link-active;
        background-image: url("data:image/svg+xml,%3Csvg width='27' height='28' viewBox='0 0 27 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.5001 0.666687C20.8639 0.666687 26.8334 6.63622 26.8334 14C26.8334 21.3638 20.8639 27.3334 13.5001 27.3334C6.13628 27.3334 0.166748 21.3638 0.166748 14C0.166748 6.63622 6.13628 0.666687 13.5001 0.666687ZM13.5001 3.33335C7.60904 3.33335 2.83342 8.10898 2.83342 14C2.83342 19.8911 7.60904 24.6667 13.5001 24.6667C19.3911 24.6667 24.1667 19.8911 24.1667 14C24.1667 8.10898 19.3911 3.33335 13.5001 3.33335ZM11.5052 7.51498L19.5052 12.8483C20.3354 13.3326 20.3842 14.4899 19.6517 15.0534L11.5052 20.4851C10.6164 21.0036 9.50008 20.3624 9.50008 19.3334V8.66669C9.50008 7.63763 10.6164 6.99647 11.5052 7.51498Z' fill='%23FAFBFC'/%3E%3C/svg%3E");
    }
}

.detail-news__img {
    max-width: 60%;
    @include margin-level(top, M);
    @include margin-level(bottom, M);
    margin-left: auto;
    margin-right: auto;

    & .z-image, & img {
        width: 100%;
        height: 100%;
    }

    @include breakpoint(v-tablet) {
        max-width: 100%;
    }
}

.detail-news__video {
    @include margin-level(top, M);
    @include margin-level(bottom, 2XL);
    max-width: 1150px;
}

.detail-news-files {
    margin-bottom: $token-spacers-m;
    &__title {
        font-weight: 600;
        // font-size: 24px;
        font-size: var(--fontSize2xl);
        line-height: 1.2;
        color: $token-colors-black-90;
        margin-bottom: $token-spacers-s;
    }
}

.detail-news-source {
    margin-bottom: $token-spacers-l;

    &__item {
        &:not(:last-child) {
            margin-bottom: $token-spacers-2-xs;
        }
    }

    &__title {
        font-weight: 600;
        font-size: var(--fontSizeL);
        line-height: 1.4;
        color: $token-colors-black;
    }

    &__value {
        font-weight: 400;
        font-size: var(--fontSizeL);
        line-height: 1.4;
        color: $token-colors-black-80;
    }
}
</style>
